/* eslint-disable react/prop-types */

import React from 'react';
import { ConfigProvider } from 'antd';
// eslint-disable-next-line import-x/no-rename-default
import antdLocale from 'locales/antdLocale';
import { isTest } from 'helpers/userSessionSettings';

/**
 * CWOConfigProvider is a wrapper component for Ant Design's ConfigProvider,
 * providing Cropwise-specific theme customizations such as colors, fonts, and motion settings.
 * It sets custom colors for Button and Tag components, as well as global theme tokens.
 *
 * Note: Properties that cannot be configured via the theme object here, e.g. the Tag cyan color,
 * should be added in the corresponding style file.
 */

const CWOConfigProvider = ({ children, ...props }) => (
  <ConfigProvider
    locale={antdLocale()}
    theme={{
      token: {
        colorPrimary: '#0071cd',
        colorWarning: '#9A6412',
        colorLink: '#0071cd',
        colorLinkHover: '#0092e4',
        colorError: '#cf3537',
        // eslint-disable-next-line @stylistic/max-len
        fontFamily: '"Noto Sans VF", "Noto Sans", Roboto, "Helvetica Neue", Helvetica, Arial, sans-serif',
        motion: !isTest,
        // make animation faster
        motionUnit: isTest ? 0 : 0.03,
      },
      components: {
        // set cropwise button colors
        Button: {
          colorPrimary: '#14803c',
          colorPrimaryHover: '#0c612c',
          colorPrimaryActive: '#0c612c',
          colorPrimaryBg: '#c3ead1',
          colorError: '#cf3537',
          colorErrorHover: '#9c2628',
          colorErrorActive: '#9c2628',
          colorErrorBg: '#ffd9d9',
          colorSuccess: '#14803c',
          colorSuccessHover: '#0c612c',
          colorSuccessActive: '#0c612c',
          colorSuccessBg: '#c3ead1',
        },
        // set cropwise tag colors
        Tag: {
          // color: 'error'
          colorError: '#cf3537',
          colorErrorBg: '#ffd9d9',
          colorErrorBorder: '#ffb3b3',
          // color: 'processing'
          colorInfo: '#0071cd',
          colorInfoBg: '#c6e6ff',
          colorInfoBorder: '#82cfff',
          // color: 'success'
          colorSuccess: '#14803c',
          colorSuccessBg: '#c3ead1',
          colorSuccessBorder: '#90d6aa',
          // color: 'warning'
          colorWarning: '#9a6412',
          colorWarningBg: '#ffe4ae',
          colorWarningBorder: '#f0c355',
        },
      },
    }}
    wave={{ disabled: true }}
    {...props}
  >
    {children}
  </ConfigProvider>
);

export default CWOConfigProvider;
